import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles, Shield, Lock, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      login(res.data.token, res.data.user);
      toast.success("Admin access granted!");
      navigate("/dashboard/admin");
    } catch (e) {
      console.error("Admin login failed:", e);
      toast.error(e.response?.data?.detail || "Invalid admin credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050810] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/home" className="inline-flex items-center gap-2 mb-6">
            <img src="/logo.png" alt="StardomFans" className="w-10 h-10 object-contain" style={{ mixBlendMode: "lighten" }} />
          </Link>
          <div className="w-16 h-16 rounded-2xl bg-[#D14A85]/10 flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-[#D14A85]" />
          </div>
          <h1 className="font-['Unbounded'] text-2xl font-bold text-white mb-2">Admin Access</h1>
          <p className="text-[#8A92A0]">Sign in with your admin credentials</p>
        </div>

        <div className="card p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-white">Admin Email</Label>
              <div className="relative mt-1">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8A92A0]" />
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-[#050810] border-[#1A2030] text-white pl-10"
                  placeholder="admin@stardomfans.com"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            </div>
            <div>
              <Label className="text-white">Password</Label>
              <div className="relative mt-1">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8A92A0]" />
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-[#050810] border-[#1A2030] text-white pl-10"
                  placeholder="Enter admin password"
                  required
                  data-testid="admin-password-input"
                />
              </div>
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#D14A85] text-white hover:bg-[#FF3377] neon-accent"
              data-testid="admin-login-btn"
            >
              {loading ? "Authenticating..." : "Access Admin Panel"}
            </Button>
          </form>
        </div>

        <p className="text-center text-[#6A7280] text-sm mt-6">
          <Link to="/home" className="text-[#EC008C] hover:underline">Back to StardomFans.com</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
